// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__19VRm","box":"Notifications_box__1mf7Y"};